import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/document-services/document-services/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const TextBlock = makeShortcode("TextBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <TextBlock slots="heading, text" width="100%" theme="lightest" alignment="yes" className="py-0 text-align-left div-p-0 left-content" mdxType="TextBlock" />
    <h2 {...{
      "id": "interested-in-early-access-to-the-pdf-accessibility-auto-tag-api"
    }}>{`Interested in Early Access to the PDF Accessibility Auto-Tag API?`}</h2>
    <p>{`Use this form to request early access to the PDF Accessibility Auto-Tag API. The API, powered by Adobe Sensei AI, improves the accessibility of PDF files by auto-tagging content for better readability using screen readers and other assistive technology.`}</p>
    <TextBlock slots="text" width="100%" theme="lightest" alignment="yes" paddingTop="5" paddingBottom='5' className="py-0 div-p-0 left-content" mdxType="TextBlock" />
    <p>{`Primary capabilities of the API include:`}</p>
    <TextBlock slots="text" width="100%" theme="lightest" alignment="yes" paddingTop="5" paddingBottom='5' className="py-0 div-p-0 left-content" mdxType="TextBlock" />
    <ul>
      <li parentName="ul">
        <b>Highly accurate content tagging:</b> Tag table headings, rows, columns, paragraphs, lists, and headings more accurately in native or scanned PDFs using  Sensei AI to improve the navigation and reading experience for users of assistive technologies such as screen readers  
      </li>
      <li parentName="ul">
        <b>Reading order identification:</b> Identify the logical flow of information, even when columns or elements that span multiple pages are present.
      </li>
      <li parentName="ul">
        <b>Wide range of document types, at scale:</b> Works on long-form text and mixed content documents across languages. Can be applied at scale to large backlogs or added to automated workflows  
      </li>
      <li parentName="ul">
        <b>Tagging report:</b> Get an excel report with information about the added tags and any content that needs to be reviewed
      </li>
    </ul>
    <TextBlock slots="text" width="100%" theme="lightest" alignment="yes" paddingTop="5" paddingBottom='5' className="py-0 div-p-0 left-content" mdxType="TextBlock" />
    <p>{`Use this form to have an Adobe representative contact you with more information about the Early Access program or to answer other questions you have about the API.`}</p>
    <TextBlock slots="text" width="100%" theme="lightest" alignment="yes" paddingTop="5" paddingBottom='5' className="py-0 div-p-0 left-content link linking" mdxType="TextBlock" />
    <p>{`You can also find more information in the `}<a title="developer documentation" href="https://developer.adobe.com/document-services/docs/overview/pdf-accessibility-auto-tag-api/">{`developer documentation`}</a>{` and the `}<a title="FAQ Link" href="https://www.adobe.com/go/dcsdk_forum">{`FAQ`}</a>{` for the PDF Services API.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      